<div class="row">
  <div class="col-md-6">
    <app-form-group>
      <label for="fumigant">Fumigant</label>
      <app-select id="fumigant" [options]="portvisitUtils.fumigants"
                  [formatter]="portvisitUtils.fumigantFormatter"
                  [(ngModel)]="fumigation().fumigant"
                  required>
      </app-select>
    </app-form-group>
    @if (showConditionalFields()) {
      <app-form-group>
        <label>Method/Application</label>
        <app-select id="fumigantApplication"
                    [options]="portvisitUtils.fumigantApplicationOptions"
                    [formatter]="portvisitUtils.fumigantApplicationFormatter"
                    [(ngModel)]="fumigation().fumigantApplication"
                    required>
        </app-select>
      </app-form-group>
    }
  </div>
  @if (showSleevesUsedRemoved()) {
  <div class="col-md-6">
      <app-form-group>
        <app-info class="formGroupLabel">
          <label>Sleeves used</label>
          <div class="tooltipContent">The number of the sleeves used in hold</div>
        </app-info>
        <input type="number" id="sleevesUsed"
               [min]="0" [max]="9999"
               (input)="portvisitUtils.ensureNumericWithMaxLength($event, 4)"
               [(ngModel)]="fumigation().sleevesUsed"
               class="form-control"
               required>
      </app-form-group>
      <app-form-group>
        <app-info class="formGroupLabel">
          <label>Removed sleeves</label>
          <div class="tooltipContent">The number of sleeves removed and disposed</div>
        </app-info>
        <input type="number" id="sleevesRemoved"
               [min]="0" [max]="9999"
               (input)="portvisitUtils.ensureNumericWithMaxLength($event, 4)"
               [(ngModel)]="fumigation().sleevesRemoved"
               class="form-control"
               required>
      </app-form-group>
  </div>
  }
</div>

@if (showConditionalFields()) {
  <div class="row">
    <div class="declaration-block col-12">
      <hr style="margin: 0.1em"/>
      <br>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <app-form-group>
        <app-info class="formGroupLabel">
          <label>Defumigator hired by</label>
          <div class="tooltipContent">Company or cargo owner/representative responsible for hiring defumigator company</div>
        </app-info>
        <input type="text" id="defumigatorHiredBy"
               [(ngModel)]="fumigation().defumigatorHiredBy" class="form-control" maxlength="64" required>
      </app-form-group>
      <app-form-group>
        <app-info class="formGroupLabel">
          <label>Defumigator hirer phone</label>
          <div class="tooltipContent">Phone number of the company or cargo owner/representative responsible for hiring the defumigator company.</div>
        </app-info>
        <input type="text" id="defumigatorHirerPhone"
               [(ngModel)]="fumigation().defumigatorHirerPhone" class="form-control" maxlength="32" required>
      </app-form-group>
    </div>
    <div class="col-md-6">
      <app-defumigator-company
        [fumigation]="fumigation()">
      </app-defumigator-company>
      <app-fumigation-stevedore
        [fumigation]="fumigation()">
      </app-fumigation-stevedore>
    </div>
  </div>
}
